import { Component, OnInit } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { environmentCommon } from '../../../../environments/environment-common';
import { BRAND } from '../../../data/brand/brand.data';
import { URLS } from '../../../data/navigation/navigation.data';
import { PRODUCT_LINES, COMPANIES } from '../../../data/product/product.data';

@Component({
  selector: 'app-alcade-engineers-page',
  templateUrl: './alcade-engineers-page.component.html',
  styleUrls: ['./alcade-engineers-page.component.scss']
})
export class AlcadeEngineersPageComponent {
  BRAND = BRAND;
  URLS = URLS;
  PRODUCT_LINES = PRODUCT_LINES;
  COMPANIES = COMPANIES;

  environment = environment;
  environmentCommon = environmentCommon;

  exploreTitle = [
    { text: $localize`:@@homePage.exploreTitle.1:Alcade Engineers`, level: 1 },
    // { text: $localize`:@@homePage.exploreTitle.2:known for ittttt` }
  ];

  ngOnInit() {
    console.log(COMPANIES[0].products)
  }
}
